// Types
type IconProps = {
  size?: number;
  className?: string;
};

/**
 * X (Twitter) icon - used for social sharing
 */
export const XTwitterIcon = ({ size = 24, className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M22.162 0H26.5L17.073 11.876L28 28H19.456L12.653 18.205L4.892 28H0.547L10.611 15.389L0 0H8.778L14.958 9.062L22.162 0ZM20.659 25.167H23.047L7.474 2.818H4.912L20.659 25.167Z" />
  </svg>
);

